import { useSelector } from 'react-redux'
import { authSelector } from 'Pages/auth'
import { useCallback } from 'react'
import { intersection } from 'Helpers'

/**
 * @description use instead of withAccessCheck HOC
 */
export const useHasAccess = () => {
	const aliases = useSelector(authSelector.getUserAliases)

	const hasAccess = useCallback(
		(access: string[]) => {
			return Boolean(intersection(aliases, access).length)
		},
		[aliases]
	)
	return hasAccess
}
